// В продакшене (Docker + nginx) запросы идут по относительному пути /api,
// и nginx проксирует их на бэкенд (см. nginx.conf).
// В режиме разработки (npm start) по умолчанию ходим напрямую на локальный бэк.
// Любой вариант можно переопределить переменной REACT_APP_API_URL при сборке/запуске.
const DEFAULT_API_URL =
    process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8080';

export const API_BASE_URL = process.env.REACT_APP_API_URL ?? DEFAULT_API_URL;

// Турнир, который показывает страница /tournament.
// Пока турнир один; при необходимости можно переопределить переменной REACT_APP_TOURNAMENT_ID.
export const TOURNAMENT_ID =
    process.env.REACT_APP_TOURNAMENT_ID ?? '0aabff45-9cd1-4d19-9e05-3c5c178839c5';

// Верхнее меню сайта (Главная, Заглушки, Конструктор заданий, Турнир).
// Пока выключено: публично раздаём только ссылку на турнир. Чтобы вернуть меню, поставьте true.
export const SHOW_NAVIGATION = false;
